<template>
  <div class="check_item">
    <h2>選択中の製品</h2>
    <!-- <p>タテ型ブラインド / ラインドレープ(スラット100mm) / LD-6117</p> -->
    <ul class="meta_container">
      <li :key="meta" class="meta_block" v-for="meta in metaList">{{ meta }}</li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import productMeta from '../../assets/json/productType.json'

export default {
  name: "CheckItem",
  computed: {
    ...mapGetters("simulator", ["editing_meta"]),
    metaList () {
      return this.editing_meta && this.editing_meta.length > 0
        ? this.editing_meta.map(({text}) => text)
        : ['(未選択)']
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/define";

.check_item {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  h2 {
    font-size: clamp(12px, 1.2vw, 20px);
  }
  .meta_container {
    display: inline-flex;
    flex-flow: column nowrap;
    // align-items: flex-end;
    padding-inline: 3em;
    margin-right: auto;
    width: auto;
    font-size: clamp(10px, 1.2vw, 20px);
    // word-break: keep-all;
    // line-break: strict;
    // word-wrap: break-word;
    // overflow-wrap: break-word;
    .meta_block {
      list-style: none;
      .meta_item {
        display: inline-block;
      }
    }
  }
}
</style>
